import { Component, Prop, Vue } from 'vue-property-decorator';
import DashService from '../../../../services/DashboardService';
const Grid = require('../../../../components/grid/grid.vue.html');

@Component({
    components: {
        Grid
    }
})
export default class Dashboard extends Vue {
    drawer: boolean = true;
    selectedSection: any = { blockId: 0, blockName: '' };
    dashnosections: string[] = [];
    selectedGrid: object = {};
    selectedHearingRep: string = '';

    public service = new DashService()

    get username() {
        if (this.$store.state.selectedRep) {
            this.selectedHearingRep = this.$store.state.selectedRep;
            return this.$store.state.selectedRep;
        }
        else {
            return this.$store.state.user.userName;
        }
    }

    switcher(block: any) {
        this.selectedSection = block;
        this.$store.dispatch("getSelectedGrid", { id: this.selectedSection.blockId, name: this.selectedSection.blockName });

        this.loadBlock();
    }

    loadBlock() {
        if (this.selectedSection)
            this.service.GetBlockDetails(this.selectedSection.blockId, this.username).then((resp) => {
                this.selectedGrid = resp;

                this.$store.dispatch("isLoading", false);
            });
    }

    hearingRepChanged() {
        if (this.selectedHearingRep)
            this.$store.dispatch("getHearingRep", this.selectedHearingRep);
        else
            this.$store.dispatch("getHearingRep", '');
        this.$store.dispatch("getSelectedGrid", {});
        this.loadDashBlocks();
        window.scrollTo(0, 0);
    }

    loadDashBlocks() {
        this.$store.dispatch("isLoading", true);
        this.service.GetBlocks(this.username)
            .then((dashResp) => {
                this.dashnosections = dashResp != undefined ? dashResp.data : [];

                this.$store.dispatch("isLoading", false);
            });

        //need to reload when the component is activated in case any data has changed since the user was here last.
        this.$store.dispatch('getSelectedGrid');
        this.$store.dispatch('getHearingRep');

        if (this.$store.state.selectedGrid != null && this.$store.state.selectedGrid.id != '') {
            this.selectedSection = {
                blockId: this.$store.state.selectedGrid.id,
                blockName: this.$store.state.selectedGrid.name
            };

            this.loadBlock();
        }
    }

    mounted() {
        this.loadDashBlocks();
    }
}


// WEBPACK FOOTER //
// ./ClientApp/src/portalhome/docketing/pages/dashboard/dashboard.ts